import { PageKeys } from "./useStandardizedTracking";
import { selectedViews } from "../../constant/table";

export const getPageKeyForSelectedView = (selectedView) => {
  switch (selectedView) {
    case selectedViews.visitSchedule:
      return PageKeys.VISIT_SCHEDULE;
    case selectedViews.highPriority:
      return PageKeys.HIGH_PRIORITY;
    case selectedViews.savedList:
      return PageKeys.SAVED_LISTS;
    case selectedViews.allPatients:
    default:
      console.warn("SelectedView not mapped to page key:", selectedView);
      return selectedView;
  }
};
